module.exports = __webpack_public_path__ + "img/amazon.484c2b63.png";